module.exports = __webpack_public_path__ + "static/media/TrafficLaw.02b02687.jpg";